<ng-container *grecoLet="videos$ | async as data">
  <greco-filter-bar [hideSeparator]="true" [filterOptions]="filterOptions" (changed)="filters$.next($event[1])">
    <div style="display: flex; flex-direction: row; gap: 16px">
      <mat-chip *ngIf="checked.length"
        >{{ checked.length }} selected
        <button class="clear" mat-icon-button (click)="clear()" matTooltip="Click to clear selected videos">
          <mat-icon style="width: 8px">clear</mat-icon>
        </button>
      </mat-chip>
      <button mat-stroked-button *ngIf="checked.length" color="primary" (click)="save()">
        <mat-icon>link</mat-icon>Link Selected
      </button>
    </div>
    <mat-checkbox
      id="select-all"
      color="primary"
      matInput
      (change)="checkAll($event, data || [])"
      matTooltip="Select All"
      style="padding-left: 16px"
      [checked]="selectAll"
      >{{ selectAll ? 'Deselect All' : 'Select All' }}</mat-checkbox
    >
  </greco-filter-bar>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <greco-table [highlight]="true" [data]="data || []">
    <!--checkbox-->
    <ng-container *grecoTableCol="''; let item; fitContent: true; sticky: true">
      <mat-checkbox
        color="primary"
        id="{{ item.communityVideo.id }}"
        matInput
        [checked]="item.checked"
        (change)="itemChecked(item, $event.checked); verifySelectAllCheck(data || [])"
      ></mat-checkbox>
    </ng-container>
    <!-- Thumbnail -->
    <div *grecoTableCol="''; fitContent: true; let item" [matTooltip]="item.communityVideo.id">
      <img
        *ngIf="item.communityVideo.video.thumbnailUrl"
        [src]="item.communityVideo.video.thumbnailUrl | safe : 'resourceUrl'"
        alt="Thumbnail not found"
        style="
          width: 56px;
          aspect-ratio: 16 / 9;
          object-fit: cover;
          border: 0px solid #685a8f;
          border-radius: 2px;
          display: block;
        "
      />
      <mat-icon *ngIf="!item.communityVideo.video.thumbnailUrl"> smart_display </mat-icon>
    </div>
    <!-- video title -->
    <ng-container>
      <p *grecoTableCol="'Title'; let item" [matTooltip]="item.communityVideo.video.title">
        {{ item.communityVideo.video.title }}
      </p>
    </ng-container>
    <!--Upload By-->
    <ng-container>
      <p *grecoTableCol="'Uploaded By'; let item" [matTooltip]="item.communityVideo.video.uploadedBy.id">
        {{ item.communityVideo.video.uploadedBy.displayName }}
      </p>
    </ng-container>
    <!-- Date -->
    <ng-container>
      <p *grecoTableCol="'Upload Date'; let item" [matTooltip]="'Upload Date'">
        {{ item.communityVideo.video.created | date }}
      </p>
    </ng-container>
    <!--Tags-->
    <ng-container>
      <mat-chip-list *grecoTableCol="'Tags'; let item">
        <greco-video-tag
          [admin]="true"
          [tag]="tag"
          *ngFor="let tag of item.communityVideo.video.tags"
          [community]="item.communityVideo.community"
        ></greco-video-tag>
      </mat-chip-list>
    </ng-container>
    <!--Watch-->
    <ng-container>
      <button
        *grecoTableCol="''; let item"
        [matTooltip]="'Watch ' + item.communityVideo.video.title"
        mat-stroked-button
        style="height: 32px; line-height: 16px; margin-left: auto"
        (click)="$event.stopImmediatePropagation(); watch(item.communityVideo)"
      >
        Watch
      </button>
    </ng-container>
  </greco-table>
  <mat-paginator
    *ngIf="pagination?.totalItems"
    showFirstLastButtons
    [length]="pagination!.totalItems || 0"
    [pageSize]="pagination!.itemsPerPage || 10"
    [pageSizeOptions]="[10, 20, 50]"
    (page)="page$.next({ page: $event.pageIndex + 1, limit: $event.pageSize })"
  ></mat-paginator>
</ng-container>
